module.exports = __webpack_public_path__ + "static/media/consierge.c6455aad.jpg";